import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { httpsCallable } from 'firebase/functions';
import { toast } from 'react-toastify';
import qs from 'qs';

import { functions } from '../../firebase';

export default function EmailVerification () {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const verifyEmailAddress = async () => {
      const { emailVerificationToken } = qs.parse(location.search.slice(1));
      
      if (!emailVerificationToken) {
        toast.error('認証トークンが見つかりません');
        history.push('/');
        return;
      }

      try {
        const verifyEmail = httpsCallable(functions, 'verifyEmail');
        const result = await verifyEmail({ emailVerificationToken });
        
        if (result.data.status === 'ok') {
          toast.success('メールアドレスの確認が完了しました');
        } else {
          toast.error(result.data.errorMessage || '認証に失敗しました');
        }
      } catch (e) {
        console.error(e);
        toast.error('認証に失敗しました');
      }
      
      history.push('/');
    };

    verifyEmailAddress();
  }, [location]);

  return (
    <div className="container p-5">
      <div className="row">
        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div className="card">
            <div className="card-body text-center">
              <h4>メールアドレスを確認中...</h4>
              <div className="spinner-border text-primary mt-3" role="status">
                <span className="visually-hidden">読み込み中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};